import type { FC, ReactNode } from "react";
import styled from "styled-components";
import { theme } from "../../theme";
import BodySmall from "../atoms/typography/BodySmall";
import Body from "../atoms/typography/Body";
import CircleButton from "../atoms/buttons/CircleButton";
import { EditIcon } from "../atoms/icons/EditIcon";

interface Props {
  title: string;
  content?: string | number;
  nodeContent?: ReactNode;
  status?: ReactNode;
  onClickEdit?: () => void;
}

const CardContainer = styled.div`
  border-left: 1.5px solid ${theme.colors.grey05};
  padding: 16px 32px;
  display: flex;
  gap: 24px;
  justify-content: space-between;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const InCardSectionTitle: FC<Props> = ({
  title,
  content,
  status,
  nodeContent,
  onClickEdit,
}) => {
  return (
    <CardContainer>
      <ContentContainer>
        <BodySmall color={theme.colors.textSecondary}>{title}</BodySmall>
        {content && <Body>{content}</Body>}
        {nodeContent && nodeContent}
        {status && status}
      </ContentContainer>
      {onClickEdit && (
        <CircleButton
          icon={<EditIcon color={theme.colors.primary} />}
          onClick={onClickEdit}
        />
      )}
    </CardContainer>
  );
};

export default InCardSectionTitle;
